/* eslint @typescript-eslint/no-explicit-any: 0 */

import Serializer from "./Serializer";
import { Answer } from "../../../app/types/Answer";
import { newUser } from "../../../app/types/User";

class AnswerSerializer extends Serializer<Answer> {
    public serialize(answer: Partial<Answer>) {
        return {
            body: answer.body,
            accepted: answer.accepted,
        };
    }

    public deserialize(data: any): Answer {
        return {
            id: data.id,
            questionId: data.question,
            body: data.body,
            author: newUser(data.user.id, data.user.username),
            createdAt: new Date(data.timestamp).toLocaleString(),
            updatedAt: new Date(data.updated).toLocaleString(),
            votes: data.votes,
            userVote: data.current_user_vote,
            comments: [],
            accepted: data.accepted,
        };
    }
}

export default AnswerSerializer;
